import {Injectable, Injector} from '@angular/core';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHandler,
  HttpHeaderResponse, HttpProgressEvent,
  HttpRequest, HttpResponse,
  HttpSentEvent, HttpUserEvent,
  HttpXsrfTokenExtractor
} from '@angular/common/http';
import {BehaviorSubject, Observable, of, throwError} from 'rxjs';
import {Router} from '@angular/router';
import {StorageService} from './storage.service';
import {catchError} from 'rxjs/operators';
import {HelperService} from './helpers';

@Injectable({
  providedIn: 'root',
})
export class TokenInterceptorService {
  constructor(
    private injector: Injector,
    private tokenExtractor: HttpXsrfTokenExtractor,
    private helper: HelperService,
    private storage: StorageService,
    private router: Router,
  ) {
  }

  private isRefreshingToken: boolean = false;
  tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any> | any> {
    if (this.isOneOfIgnoreredUrl(request)) {
      return next.handle(request);
    }
    const storage = this.injector.get(StorageService);
    const router = this.injector.get(Router);
    const authData = storage.getItem('premium|auth')
    let token = null;
    if (authData && authData.token) {
      token = authData.token;
    }
    return next.handle(this.addTokenToRequest(request, token, '')).pipe(
      catchError((err) => {
        if (request.url === this.helper.getAuthUrl()) {
          return throwError(err);
        }
        if (err instanceof HttpErrorResponse) {
          switch ((err as HttpErrorResponse).status) {
            case 401:
              /*//2FA
              if (_.get(err, 'error.error_description') === '2FA') {
                return throwError(err);
              }
              //TODO ni najlepsa resitev
              if (
                _.get(request, 'body', '') &&
                _.get(request, 'body', '').indexOf('refresh_token') !== -1
              ) {
                storage.clearToken();
                router.navigate(['/login']);
              }*/
              return this.handle401Error(request, next);
            case 400:
              return throwError(err);
            case 403:
              return throwError(err);
            default:
              return throwError(err);
          }
        } else {
          return throwError(err);
        }
      }),
    );
  }

  private isOneOfIgnoreredUrl(request: any): boolean {
    // return /public/.test(request.url) || /hooks.slack.com/.test(request.url);
    return false;
  }

  private addTokenToRequest(request: HttpRequest<any>, token: string, XSRFToken: string): HttpRequest<any> {
    if (!token) {
      return request.clone();
    }
    const useToken = true;
    /*
    if (request.body && _.isString(request.body)) {
      if (_.get(request, 'body', '').indexOf('refresh_token') !== -1) {
        useToken = false;
      }
    }
    if (!token) {
      useToken = false;
    }
    */

    if (useToken) {
      return request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
    } else {
      return request.clone();
    }
  }


  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    this.storage.removeItem('premium|auth');
    this.router.navigate(['/login']);
    return of(false);
    //const httpClientMF = this.injector.get(HttpClient);
    //const authService = this.injector.get(AuthenticationService);
    /*if (!this.isRefreshingToken) {
      this.isRefreshingToken = true;

      // Reset here so that the following requests wait until the token
      // comes back from the refreshToken call.
      this.tokenSubject.next(null);

      return httpClientMF.refreshToken().pipe(
        switchMap((token: any) => {
          debugger;
          const accessToken = _.get(token, 'access_token', undefined);
          if (accessToken) {
            this.tokenSubject.next(accessToken);
            return next.handle(this.addTokenToRequest(request, accessToken, ''));
          }

          return <any>authService.logout();
        }),
        catchError((err) => {
          debugger;
          return <any>authService.logout();
        }),
        finalize(() => {
          debugger;
          this.isRefreshingToken = false;
        }),
      );
    } else {
      this.isRefreshingToken = false;

      return this.tokenSubject.pipe(
        filter((token) => token != null),
        take(1),
        switchMap((token) => {
          return next.handle(this.addTokenToRequest(request, token, ''));
        }),
      );
    }*/
  }
}
